import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import { createWard } from "../api/coreApi";
import { fkId } from "../utils/coreHelpers";

export default function WardFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  goNext,
  hospitals = [],
  selectedHospitalId,
  setSelectedHospitalId,
  setSelectedWardId,
}) {
  if (!hospitals.length) return <Alert severity="info">Create Hospital first (Step 1).</Alert>;

  const hospitalOptions = hospitals.map((h) => ({
    value: fkId(h.hospital_id || h.id),
    label: `${h.name} (${h.city || "-"})`,
  }));

  const onSubmit = async (vals, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const payload = {
        organization: selectedHospitalId,
        name: vals.name,
        ward_type: vals.ward_type,
        floor: vals.floor,
      };

      const res = await createWard(payload);
      const newWardId = fkId(res?.data?.ward_id || res?.data?.id);
      if (newWardId) setSelectedWardId(newWardId);

      goNext();
      await refreshAll();
      helpers?.reset?.();
    } catch (e) {
      setErr(e?.response?.data ? JSON.stringify(e.response.data) : "Create ward failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 2: Ward</Typography>

      <EntityForm
        title="Create Ward"
        loading={loading}
        initialValues={{
          _hospital: selectedHospitalId || hospitalOptions[0]?.value || "",
          name: "",
          ward_type: "GENERAL",
          floor: "",
        }}
        fields={[
          {
            name: "_hospital",
            label: "Hospital",
            type: "select",
            required: true,
            options: hospitalOptions,
          },
          { name: "name", label: "Ward Name", required: true },
          {
            name: "ward_type",
            label: "Ward Type",
            type: "select",
            required: true,
            options: [
              { value: "ICU", label: "ICU" },
              { value: "EMERGENCY", label: "Emergency" },
              { value: "GENERAL", label: "General" },
              { value: "OT", label: "OT" },
              { value: "OTHER", label: "Other" },
            ],
          },
          { name: "floor", label: "Floor (optional)" },
        ]}
        onSubmit={(vals, helpers) => {
          if (vals._hospital && vals._hospital !== selectedHospitalId) {
            setSelectedHospitalId(vals._hospital);
          }
          return onSubmit(vals, helpers);
        }}
      />
    </Box>
  );
}